module.exports = __webpack_public_path__ + "static/media/ic_empty_employ.a9e6dff3.svg";